import { EDIT_ACCESS_ROLE_LIST, Role } from '../_models/role';
import { SpargingStatus } from '../_models/sparging-status';

export type Flask = 'A' | 'B' | 'C' | 'D';

const EDIT_ACCESS_ROLES_SET = new Set<Role>(EDIT_ACCESS_ROLE_LIST);

export function hasExperimentEditAccess(role: Role | undefined): boolean {
  return role !== undefined && EDIT_ACCESS_ROLES_SET.has(role);
}

export function getSpargingStatus(status: string): SpargingStatus | null {
  switch (status) {
    case 'FixedA':
    case 'FixedB':
    case 'FixedC':
    case 'FixedD':
      return SpargingStatus.Fixed;
    case 'DisabledA':
    case 'DisabledB':
    case 'DisabledC':
    case 'DisabledD':
      return SpargingStatus.Disabled;
    case 'ThresholdA':
    case 'ThresholdB':
    case 'ThresholdC':
    case 'ThresholdD':
      return SpargingStatus.Threshold;
    default:
      return null;
  }
}

export function convertSpargingStatus(status: SpargingStatus): string | null {
  switch (status) {
    case SpargingStatus.Disabled:
      return 'Disabled';
    case SpargingStatus.Fixed:
      return 'Fixed';
    case SpargingStatus.Threshold:
      return 'Threshold';
    default:
      return null;
  }
}

export function convertSpecGainToString(
  specGain: boolean | null | undefined,
  flask: Flask,
): string | undefined {
  if (specGain == null) return undefined;
  return specGain ? `high${flask}` : `low${flask}`;
}

export function convertBooleanToSpecGain(inputType: string): boolean | undefined {
  const highGainTypes = ['highA', 'highB', 'highC', 'highD'];
  const lowGainTypes = ['lowA', 'lowB', 'lowC', 'lowD'];

  if (highGainTypes.includes(inputType)) return true;
  if (lowGainTypes.includes(inputType)) return false;
  return undefined;
}

export function convertInputTypeToBoolean(inputType: string): boolean | undefined {
  const baseTypes = ['BaseA', 'BaseB', 'BaseC', 'BaseD', 'ChemoBaseA', 'ChemoBaseB'];
  const acidTypes = ['AcidA', 'AcidB', 'AcidC', 'AcidD', 'ChemoAcidA', 'ChemoAcidB'];

  if (baseTypes.includes(inputType)) return true;
  if (acidTypes.includes(inputType)) return false;
  return undefined;
}

export function convertBooleanToInputType(
  isBase: boolean | null | undefined,
  flask: Flask,
  isChemo = false,
): string | undefined {
  if (isBase == null) return undefined;

  const prefix = isChemo ? 'Chemo' : '';
  const type = isBase ? 'Base' : 'Acid';
  return `${prefix}${type}${flask}`;
}

export const NOTIFICATION_TOOLTIP =
  'Enable email notifications to be alerted of any experiment updates. Notifications are only available for experiments that are in progress, and only one user can subscribe per experiment.';
